import { Box, Divider } from "@mui/material";
import React, { useEffect, useState } from "react";
import Header from "./partials/Header";
import { ProductAnalyzerProvider } from "../../../contexts/productAnalyzerContext";
import ProductDetail from "./partials/ProductDetail";
import Footer from "./partials/Footer";
import ProfitCalculator from "./partials/QuickInfo";
import QuickInfo from "./partials/QuickInfo";
import BuyboxAnalysis from "./partials/BuyboxAnalysis";
import { colors } from "./config";

export type TAmazonEmbededViewType = "profitCalculator" | "buyboxAnalysis";

export default function AmazonEmbededView() {
  const [view, setView] = useState<TAmazonEmbededViewType>("profitCalculator");

  useEffect(() => {
    const sendHeight = () => {
      const height = document.body.offsetHeight;

      window.parent.postMessage({ type: "RESIZE_IFRAME", height }, "*");
    };

    sendHeight();

    const observer = new ResizeObserver(sendHeight);
    observer.observe(document.body);

    return () => observer.disconnect();
  }, []);

  return (
    <ProductAnalyzerProvider>
      <Box sx={{ px: 1 }}>
        <Header view={view} setView={setView} />
        <Divider
          sx={{
            height: "1px",
            backgroundColor: colors.border.divider,
            my: 0,
          }}
        />
        {view === "profitCalculator" && (
          <>
            <ProductDetail />
            <Divider
              sx={{
                height: "1px",
                backgroundColor: colors.border.divider,
                my: 0,
              }}
            />
            <QuickInfo />
          </>
        )}
        {view === "buyboxAnalysis" && (
          <>
            <BuyboxAnalysis />
          </>
        )}
        <Divider
          sx={{
            height: "1px",
            backgroundColor: colors.border.divider,
            my: 0,
          }}
        />
        <Footer />
      </Box>
    </ProductAnalyzerProvider>
  );
}
